import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';


@Injectable({
  providedIn: 'root'
})
export class MicrotasksService {

  constructor(private apiService: ApiBaseService) { }

  async getMicroTasks(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('MicroTasks/GetMicroTasks', payLoad, true, true);
  }
  async addMicroTask(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('MicroTasks/AddMicroTask', payLoad, true, true);
  }
  async editMicroTask(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('MicroTasks/EditMicroTask', payLoad, true, true);
  }
  async deleteMicroTask(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('MicroTasks/DeleteMicroTask', payLoad, true, true);
  }

  async getDocumentFolders(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplatesService/GetDocumentFolders', payload, true, true);
  }

  async getTemplateFile(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplatesService/GetTemplateFile', payload, true, true);
  }

  async deleteTemplateFile(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplatesService/DeleteTemplateFile', payload, true, true);
  }

  async saveMicroTasks(payload: any): Promise<any> {
    return this.apiService.httpRequest('MicroTasks/SaveMicroTasks', payload, true, true);
  }

  async deleteMicroTasks(payload: any): Promise<any> {
    return this.apiService.httpRequest('MicroTasks/DeleteMicroTasks', payload, true, true);
  }
}